<form class="mr-5 ml-5 mt-5 mb-3" (ngSubmit)="goPaso()">
  <header class="header">
    <h1 class="h5 mb-4">Requisitos Generales</h1>
  </header>

  <!-- CAPACIDAD TECNICA -->
  <section class="row border-bottom mb-4" *ngIf="mostrarCapTecnica">
    <section class="col-md-4 col-sm-12">
      <app-ayudas
        [ayuda]="
          ayudaService.capacidad(
            datoSolicitudSharedModel.tipo_solicitud,
            datoSolicitudSharedModel.tipo_rnt,
            rnt.sub_categoria_id,
            rnt.estado_rnt_id,
            rnt.estado_solicitud_id
          )
        "
      >
      </app-ayudas>

      <!-- Titulo -->
      <header class="row d-flex align-items-center">
        <figure class="m-auto">
          <img
            src="../../../../../../../../assets/icons/tecnica.png"
            class="d-inline-block p-2 rounded-circle"
            alt=""
            height="60"
          />
        </figure>

        <div class="col">
          <label class="text-muted small mb-0">Capacidad <br />
            <strong class="h5 text-body">Técnica</strong>
          </label>
        </div>
      </header>

      <form [formGroup]="formCapacidadTecnica" (ngSubmit)="onAgregarCapacidadTecnica()">
        <!-- Elemento -->
        <div class="form-group mb-1">
          <label class="small text-secondary {{requiredClass}}">{{labelTiCapacidad}} </label>
          <select
            id="tipo_capacidad_tecnica_id"
            formControlName="tipo_capacidad_tecnica_id"
            class="form-control"
            (change)="capacidadTecnicaChange( $event )"
          >
          <option value=""></option>
            <ng-container *ngFor="let item of capacidadTecnica">
              <option [value]="item.tipo_capacidad_tecnica_id">
                {{ item.descripcion }}
              </option>
            </ng-container>
          </select>

          <!-- Si es Software dfe alojamiento, muestra este campo -->
          <div *ngIf="(formCapacidadTecnica.value.tipo_capacidad_tecnica_id != null) && (hostingSoftwareId != null) && (formCapacidadTecnica.value.tipo_capacidad_tecnica_id == hostingSoftwareId)">
            <label class="small text-secondary  {{requiredClass}}">Sub tipo</label>
            <select
              id="sub_tipo_capacidad_tecnica_id"
              formControlName="sub_tipo_capacidad_tecnica_id"
              class="form-control"
              (change)="hostingSoftwareChange( $event )"
            >
              <ng-container *ngFor="let item of hostingSoftwareData">
                <option [value]="item.sub_tipo_capacidad_tecnica_id">
                  {{ item.descripcion }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>
        <!-- Descripcion -->
        <div class="form-group mb-1">
          <label class="small text-secondary {{requiredClass}}">Descripción</label>
          <input class="form-control" formControlName="descripcion" />
        </div>
        <!-- Cantidad -->
        <div class="form-group mb-4">
          <label class="small text-secondary {{requiredClass}}">Cantidad</label>
          <input class="form-control" formControlName="cantidad" />
          <div
            id="cantidad"
            *ngIf="
              !formCapacidadTecnica.controls.cantidad.valid &&
              formCapacidadTecnica.get('cantidad').dirty
            "
          >
            <p
              class="small text-danger mt-1 position-absolute font-weight-bold"
              text-right
            >
              Solo se permiten valores numéricos (máx. 7 dígitos)
            </p>
          </div>
        </div>
        <!-- Btn guardar/Editar -->
        <div class="form-group mt-auto text-center">
          <ng-container
            *ngIf="selectCapacidadTecnica == null; else editarCapacidadTecnica"
          >
            <button
              type="button"
              class="btn btn-primary paso-capacidad-btn-inicio w-100 p-1"
              [disabled]="!formCapacidadTecnica.valid"
              (click)="onAgregarCapacidadTecnica()"
            >
              Agregar
            </button>
          </ng-container>
          <ng-template #editarCapacidadTecnica>
            <button
              type="button"
              class="btn btn-primary paso-capacidad-btn-inicio w-100 p-1"
              [disabled]="!formCapacidadTecnica.valid"
              (click)="onModificarCapacidadTecnica()"
            >
              Editar
            </button>
          </ng-template>
        </div>
      </form>
    </section>

    <!-- Tbl der capacidades tecnicas agregadas -->
    <div class="col-md col-sm-12">
      <label
        *ngIf="capacidadTecnicaVieja && capacidadTecnicaVieja.activo"
        class="text-muted"
        ><strong>Capacidad Tecnica Anterior</strong></label
      >
      <div
        *ngIf="capacidadTecnicaVieja && capacidadTecnicaVieja.activo"
        class="mb-2 overflow-capacidad"
        [innerHTML]="capacidadTecnicaVieja.descripcion"
      ></div>
      <section
        *ngIf="
          capacidadesTecnicas != null && capacidadesTecnicas.length > 0;
          else explicativo_t
        "
      >
        <app-tablas
          [headers]="headersCapacidadTecnica"
          class="table-responsive overflow"
          [paginar]="false"
        >
          <tr *ngFor="let item of capacidadesTecnicas" class="small">
            <td>{{ item.descripcion_tipo }}</td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.cantidad }}</td>
            <td>
              {{(item.descripcion_sub_tipo) ? item.descripcion_sub_tipo : 'No Aplica'}}
            </td>
            <td class="text-nowrap">
              <img
                src="/assets/icons/edit.png"
                class="pointer"
                alt=""
                (click)="onCargarEditarTecnica(item)"
                height="25"
              />
              <img
                src="/assets/icons/delete.png"
                class="pointer ml-2"
                alt=""
                (click)="onEliminarCapacidadTecnica(item)"
                height="25"
              />
            </td>
          </tr>
        </app-tablas>
      </section>
    </div>
    <!-- Txt que se visualiza cuando no hay CT agregada -->
    <ng-template #explicativo_t>
      <section class="col-md col-sm-12">

        <h6 class="font-weight-bold">{{ Titulo_Capacidad_tecnica }}</h6>
        <h6 class="font-weight-bold">Capacidad técnica</h6>
        <div [innerHTML]="Texto_Capacidad_tecnica" class="text-secondary"></div>

        <!--<div *ngIf="!Paso2Norequerido">
          <p class="text-danger">Es obligatorio</p>
        </div>-->

        <div *ngIf="requeridoCapTecnica">
          <p style="color: red">Es obligatorio</p>
        </div>

      </section>
    </ng-template>
  </section>

  <!-- CAPACIDAD OPERATIVA -->
  <section class="row border-bottom mb-4" *ngIf="mostrarCapOperativa">
    <section class="col-md-4 col-sm-12">
      <header class="row d-flex align-items-center">
        <figure class="m-auto">
          <img
            src="../../../../../../../../assets/icons/operativa.png"
            class="d-inline-block p-2 rounded-circle"
            alt=""
            height="60"
          />
        </figure>
        <div class="col">
          <label class="small text-muted mb-0"
            >Capacidad <br /><strong class="h5 text-body"
              >Operativa</strong
            ></label
          >
        </div>
      </header>

      <form
        [formGroup]="formCapacidadOperativa"
        (ngSubmit)="onAgregarCapacidadOperativa()"
      >
      <!-- Formacion Empleado -->
        <div class="form-group mb-1">
          <div *ngIf="Paso2Norequerido; else Obligatorio1A">
            <label for="forma_empleado" class="small text-secondary"
              >Formación de empleados</label
            >
          </div>
          <ng-template #Obligatorio1A>
            <label for="forma_empleado" class="small text-secondary {{requiredClassOp}}"
              >Formación de empleados</label
            >
          </ng-template>
          <!-- Formacion empleados -->
          <select
            id="forma_empleado"
            formControlName="formacion_empleado_id"
            class="form-control"
          >
            <ng-container *ngFor="let item of formacionEmpleo">
              <option [ngValue]="item.formacion_empleado_id">
                {{ item.descripcion }}
              </option>
            </ng-container>
          </select>
        </div>
        <!-- Numero empleados -->
        <div class="form-group mb-4">
          <div *ngIf="Paso2Norequerido; else Obligatorio3B">
            <label class="small text-secondary">Número de empleados</label>
          </div>
          <ng-template #Obligatorio3B>
            <label class="small text-secondary {{requiredClassOp}}"
              >Número de empleados</label
            >
          </ng-template>
          <input class="form-control" formControlName="numero_empleados" />
          <div
            id="numero_empleados"
            *ngIf="
              !formCapacidadOperativa.controls.numero_empleados.valid &&
              formCapacidadOperativa.get('numero_empleados').dirty
            "
          >
            <p
              class="small text-danger mt-1 position-absolute font-weight-bold"
              text-right
            >
              Solo se permiten valores numéricos (máx. 5 dígitos)
            </p>
          </div>
        </div>
        <div class="form-group mt-auto text-center">
          <ng-container
            *ngIf="
              selectCapacidadOperativa == null;
              else editarCapacidadOperativa
            "
          >
            <button
              type="button"
              class="btn btn-primary paso-capacidad-btn-inicio w-100 p-1"
              [disabled]="!formCapacidadOperativa.valid"
              (click)="onAgregarCapacidadOperativa()"
            >
              Agregar
            </button>
          </ng-container>
          <ng-template #editarCapacidadOperativa>
            <button
              type="button"
              class="btn btn-primary paso-capacidad-btn-inicio w-100 p-1"
              [disabled]="!formCapacidadOperativa.valid"
              (click)="onModificarCapacidadOperativa()"
            >
              Editar
            </button>
          </ng-template>
        </div>
      </form>
    </section>

    <!-- Tbl der capacidades operativas agregadas -->
    <div class="col-md col-sm-12">
      <label
        class="text-muted"
        *ngIf="capacidadOperativaVieja && capacidadOperativaVieja.activo"
        ><strong>Capacidad Operativa Anterior</strong></label
      >
      <div
        class="mb-2 overflow-capacidad"
        [innerHTML]="capacidadOperativaVieja.descripcion_capacidad_operativa"
        *ngIf="capacidadOperativaVieja && capacidadOperativaVieja.activo"
      ></div>
      <section
        *ngIf="
          capacidadesOperativas != null && capacidadesOperativas.length > 0;
          else explicativo_o
        "
      >
        <app-tablas
          [headers]="headersCapacidadOperativa"
          class="table-responsive overflow"
          [paginar]="false"
        >
          <tr *ngFor="let item of capacidadesOperativas" class="small">
            <td>{{ item.descripcion }}</td>
            <td>{{ item.numero_empleados }}</td>
            <td>
              <img
                src="/assets/icons/edit.png"
                class="pointer"
                alt=""
                height="25"
                (click)="onCargarEditarOperativa(item)"
              />
              <img
                src="/assets/icons/delete.png"
                class="pointer ml-2"
                alt=""
                height="25"
                (click)="onEliminarCapacidadOperativa(item)"
              />
            </td>
          </tr>
        </app-tablas>
      </section>
    </div>

    <!-- Txt que se visualiza cuando no hay CO agregada -->
    <ng-template #explicativo_o>
      <section class="col-md col-sm-12">
        <h6 class="font-weight-bold">{{Titulo_Capacidad_Operativa}}</h6>
        <h6 class="font-weight-bold">Capacidad operativa</h6>

        <div [innerHTML]="Texto_Capacidad_Operativa" class="text-secondary"></div>

        <div *ngIf="requeridoCapOperativa">
          <p style="color: red">Es obligatorio</p>
        </div>
      </section>
    </ng-template>
  </section>

  <!-- Botonera -->
  <footer class="text-right p-3">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button
        type="button"
        class="
          btn btn-outline-primary
          paso-capacidad-info-btn-inicio
          mr-2
          pl-4
          pr-4
        "
        (click)="onRegresarPaso()"
      >
        Atras
      </button>

      <button
        type="submit"
        class="btn btn-primary paso-capacidad-btn-inicio"
        [disabled]="isDisableBtn"
      >
        Siguiente
      </button>
    </div>
  </footer>
</form>
